module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-13.f6969774.jpg";